import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { FormatNumber, Text } from '@reveni-io/reveni-ui'

import { getImportErrorRowValue } from '@/inventory/pages/InventoryPage/ImportInventoryDataDrawer/ImportResultModal/helpers'

import * as Styles from './styles'

const ImportErrorRowsDetail = ({ column, rows }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Styles.Container>
      <Styles.Table>
        <Styles.Head>
          <tr>
            <Styles.HeaderCell>
              <Text type="allCapsS" color={theme.colors.text.subtle}>
                {t('Fila')}
              </Text>
            </Styles.HeaderCell>
            <Styles.HeaderCell>
              <Text type="allCapsS" color={theme.colors.text.subtle}>
                {t('Campo')}
              </Text>
            </Styles.HeaderCell>
            <Styles.HeaderCell>
              <Text type="allCapsS" color={theme.colors.text.subtle}>
                {t('Valor')}
              </Text>
            </Styles.HeaderCell>
          </tr>
        </Styles.Head>
        <tbody>
          {rows.map(row => (
            <Styles.BodyRow key={row.row_number}>
              <Styles.Cell>
                <Text type="bodySRegular">
                  <FormatNumber>{row.row_number}</FormatNumber>
                </Text>
              </Styles.Cell>
              <Styles.Cell>
                <Text type="bodyMonospaced">{column}</Text>
              </Styles.Cell>
              <Styles.Cell>
                <Text type="bodySRegular" color={theme.colors.danger.onSurface}>
                  {getImportErrorRowValue(row.value)}
                </Text>
              </Styles.Cell>
            </Styles.BodyRow>
          ))}
        </tbody>
      </Styles.Table>
    </Styles.Container>
  )
}

export default ImportErrorRowsDetail
